module.exports = __webpack_public_path__ + "img/nochooseup.ae424a1f.svg";